import React from 'react';
import { Stack, Typography, Box } from '@mui/material';
import { Operation } from '../../../../../networkRequest/operationsService';
import { OperationDate, OperationType } from '../../../components';

interface DetailLineItemsProps {
  operation: Operation;
}

const DetailLineItems: React.FC<DetailLineItemsProps> = ({ operation }) => {
  return (
    <Stack spacing={2}>
      <Typography variant='xxl'>
        {operation.title}
      </Typography>
      <Typography variant='body1'>
        {operation.agency_assigned_identifier}
      </Typography>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Box sx={{ flex: 1 }}>
          <OperationDate 
            date={operation.start_date} 
            label='Start'
            labelVariant='caption'
          />
        </Box>
        <Box sx={{ flex: 1 }}>
          <OperationDate 
            date={operation.end_date} 
            label='End'
            labelVariant='caption'
          />
        </Box>
      </Box>
      {operation.description && (
        <Typography variant='body1'>
          {operation.description}
        </Typography>
      )}
      <OperationType 
        isPlanned={operation.is_planned}
        isEmergency={operation.is_emergency}
      />
    </Stack>
  );
};

export default DetailLineItems;